<template>
  <div class="pengaturan-umum">
    <SOSlotBase
      :container-name="`landing-page-pengaturan-umum`"
      :loading="isLoading"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Pengaturan Umum'"
          :type="'back'"
          @back="back"
        />
      </template>
      <template v-slot:loading-page>
        <SOLoadingPage />
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <SOInformation title="" myStyle="padding: 0 !important">
            <template v-slot:subtitle>
              <p class="m-d-0">
                <b>Info: </b> Setelah mengubah pengaturan, lakukan buka tutup
                aplikasi kasir, agar mendapatkan data pengaturan terbaru.
              </p>
            </template>
          </SOInformation>
          <div class="f-14 f-regular f-c-primary p-y-16">
            <label class="m-d-0">
              Pengaturan yang berlaku untuk seluruh outlet dan seluruh transaksi
              pada akun owner ini.
            </label>
          </div>
          <div class="separator m-x-min m-d-20"></div>
          <div class="m-x-min">
            <template v-if="getMenuEpayment">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{ getMenuEpayment.title }}</label>
                    <div class="align-items-center">
                      <SOIconBase viewBox="0 0 20 20" width="20" height="20">
                        <template v-slot:icon>
                          <ChevronRight2020 />
                        </template>
                      </SOIconBase>
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div
                    class="limited"
                    v-if="getSubTitleEpayment.jenisEmoney === 1"
                  >
                    <label class="m-d-0 text-container">
                      <div class="epayment-container">Tipe</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ getSubTitleEpayment.tipe }}
                      </div>
                    </label>
                    <label class="m-d-0 text-container">
                      <div class="epayment-container">Jika kedaluwarsa</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ getSubTitleEpayment.JikaKedaluwarsa }}
                      </div>
                    </label>
                  </div>
                  <div
                    class="limited"
                    v-if="getSubTitleEpayment.jenisEmoney === 2"
                  >
                    <label class="m-d-0 text-container">
                      <div class="epayment-container">Masa aktif cashback</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">Selamanya</div>
                    </label>
                  </div>
                  <div class="limited" v-if="!getSubTitleEpayment.jenisEmoney">
                    <label class="m-d-0 d-flex">
                      <i>Belum diatur</i>
                    </label>
                  </div>
                  <div
                    class="clik"
                    @click="linkTo(getMenuEpayment.linkTo)"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>

            <template v-if="getMenuCashback">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{ getMenuCashback.title }}</label>
                    <div class="align-items-center">
                      <SOIconBase viewBox="0 0 20 20" width="20" height="20">
                        <template v-slot:icon>
                          <ChevronRight2020 />
                        </template>
                      </SOIconBase>
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 text-container">
                      <div>Masa Aktif</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ cashbackActivePeriod }} Hari
                      </div>
                    </label>
                  </div>
                  <div
                    class="clik"
                    @click="linkTo(getMenuCashback.linkTo)"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>

            <template v-if="getMenuPointActivePeriod">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{
                      getMenuPointActivePeriod.title
                    }}</label>
                    <div class="align-items-center">
                      <SOIconBase viewBox="0 0 20 20" width="20" height="20">
                        <template v-slot:icon>
                          <ChevronRight2020 />
                        </template>
                      </SOIconBase>
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    Tipe:
                    <span class="f-c-primary">
                      {{ getSubtitlePointActivePeriod }}
                    </span>
                  </div>
                  <div
                    class="clik"
                    @click="linkTo(getMenuPointActivePeriod.linkTo)"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>

            <template v-if="getMenuReminder">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{ getMenuReminder.title }}</label>
                    <div class="align-items-center">
                      <SOIconBase viewBox="0 0 20 20" width="20" height="20">
                        <template v-slot:icon>
                          <ChevronRight2020 />
                        </template>
                      </SOIconBase>
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div
                    class="limited"
                    v-if="
                      getSubTitleReminder.deposit === 'Belum diatur' &&
                      getSubTitleReminder.epayment === 'Belum diatur' &&
                      getSubTitleReminder.poin === 'Belum diatur'
                    "
                  >
                    <label class="m-d-0 d-flex">
                      <i>Belum diatur</i>
                    </label>
                  </div>
                  <div v-else>
                    <label class="m-d-0 text-container">
                      <div class="reminder-container">E-Payment</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ getSubTitleReminder.epayment }}
                      </div>
                    </label>
                    <label class="m-d-0 text-container">
                      <div class="reminder-container">Deposit</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ getSubTitleReminder.deposit }}
                      </div>
                    </label>
                    <label class="m-d-0 text-container">
                      <div class="reminder-container">poin</div>
                      <div>:</div>
                      <div class="f-c-primary m-l-4">
                        {{ getSubTitleReminder.poin }}
                      </div>
                    </label>
                  </div>
                  <div
                    class="clik"
                    @click="linkTo(getMenuReminder.linkTo)"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>
            <!-- Menu laporan disabled, nunggu info release -->
            <!-- <SOSlotCard v-if="getMenuLaporan" :card-type="`none`">
                            <template v-slot:card_head>
                                <div class="d-flex-between-center">
                                    <label class="m-d-0">{{ getMenuLaporan.title }}</label>
                                    <div class="align-items-center">
                                        <SOIconBase viewBox="0 0 20 20" width="20" height="20">
                                            <template v-slot:icon>
                                                <ChevronRight2020 />
                                            </template>
                                        </SOIconBase>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:card_body>.limited
                                <div
                                    class="limited"
                                    v-if="selectedItemBiaya.length === 0 && selectedSumberDana.length === 0"
                                >
                                    <label class="m-d-0 d-flex">
                                        <i>Belum diatur</i>
                                    </label>
                                </div>
                                <div v-else>
                                    <label class="m-d-0 d-flex">
                                        <span class="f-c-midgrey m-r-4">Sumber Dana:</span>
                                        <span class="f-c-primary">
                                            {{ selectedSumberDana.length ? "Ada" : getSubTitleLaporan.sumberDana }}
                                        </span>
                                    </label>
                                    <label class="m-d-0 d-flex">
                                        <span class="f-c-midgrey m-r-4">Item Biaya:</span>
                                        <span class="f-c-primary">
                                            {{ selectedItemBiaya.length ? "Ada" : getSubTitleLaporan.itemBiaya }}
                                        </span>
                                    </label>
                                </div>
                                <div class="clik" @click="linkTo(getMenuLaporan.linkTo)"></div>
                            </template>
                        </SOSlotCard> -->

            <template v-if="getMenuTake">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{ getMenuTake.title }}</label>
                    <div class="align-items-center">
                      <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4"
                        >Pengaturan Konsumen:
                      </span>
                      <span class="f-c-primary">{{
                        subtitleAmbilPelunasan
                      }}</span>
                    </label>
                  </div>
                  <div class="clik" @click="linkTo(getMenuTake.linkTo)"></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>

            <template v-if="getMenuPelunasanInvoice">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{
                      getMenuPelunasanInvoice.title
                    }}</label>
                    <div class="align-items-center">
                      <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4">Pengaturan Kasir: </span>
                      <span class="f-c-primary">{{
                        subtitlePelunasanInvoice
                      }}</span>
                    </label>
                  </div>
                  <div
                    class="clik"
                    @click="linkTo(getMenuPelunasanInvoice.linkTo)"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>
            <template v-if="getMenuWaVerification">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{
                      getMenuWaVerification.title
                    }}</label>
                    <div class="align-items-center">
                      <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4">Pengaturan: </span>
                      <span class="f-c-primary">{{
                        enableWaVerification ? "Aktif" : "Tidak Akitf"
                      }}</span>
                    </label>
                  </div>
                  <div class="clik" @click="openWaVerificationModal()"></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>
            <template v-if="getMenuNotaWa">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{ getMenuNotaWa.title }}</label>
                    <div class="align-items-center">
                      <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4">Text: </span>
                      <span class="f-c-primary">{{
                        notaWaSetting.enable_nota_text ? "Aktif" : "Tidak Akitf"
                      }}</span>
                    </label>
                  </div>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4">PDF: </span>
                      <span class="f-c-primary">{{
                        notaWaSetting.enable_nota_pdf ? "Aktif" : "Tidak Akitf"
                      }}</span>
                    </label>
                  </div>
                  <div class="clik" @click="linkTo(getMenuNotaWa.linkTo)"></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>
            <!-- MENU RECOMMENDATION -->
            <template v-if="getMenuServiceRecommendation">
              <SOSlotCard :card-type="`none`">
                <template v-slot:card_head>
                  <div class="d-flex-between-center">
                    <label class="m-d-0">{{
                      getMenuServiceRecommendation.title
                    }}</label>
                    <div class="align-items-center">
                      <img src="@/assets/icons/chevron_right_4.svg" alt="" />
                    </div>
                  </div>
                </template>
                <template v-slot:card_body>
                  <div>
                    <label class="m-d-0 d-flex">
                      <span class="f-c-midgrey m-r-4">Pengaturan: </span>
                      <span class="f-c-primary">{{
                        enableServiceRecommendation ? "Aktif" : "Tidak Akitf"
                      }}</span>
                    </label>
                  </div>
                  <div
                    class="clik"
                    @click="openServiceRecommendationModal()"
                  ></div>
                </template>
              </SOSlotCard>
              <div class="separator-line"></div>
            </template>
            <!-- end: MENU RECOMMENDATION -->
          </div>
        </div>
      </template>
    </SOSlotBase>
    <ModalWaVerificationSetting ref="modalWaVerificationSetting" />
    <ModalServiceRecommendationSetting
      ref="modalServiceRecommendationSetting"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import ChevronRight2020 from "@/so-components/global/icons/iconPacks/ChevronRight2020.vue";
import ModalWaVerificationSetting from "./modal/WaVerificationSettingModal.vue";
import ModalServiceRecommendationSetting from "./modal/ServiceRecommendationSettingModal.vue";

import { moduleName } from "../store/state";
import subMenu from "../static/subMenu";
import { betaKeys } from "@/store/utils/vars";

export default {
  name: "DashboardPengaturanUmum",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOSlotCard,
    SOLoadingPage,
    SOIconBase,
    ChevronRight2020,
    SOInformation,
    ModalWaVerificationSetting,
    ModalServiceRecommendationSetting,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.init();
      vm.smartTrackingView("pengaturan_umum");
    });
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(moduleName, {
      subMenus: "subMenu",
      subTitle: "subTitle",
      pengaturanLaporan: "pengaturanLaporan",
      enableWaVerification: "enableWaVerification",
      notaWaSetting: "notaWaSetting",
      pointActivePeriod: "pointActivePeriod",
      enableServiceRecommendation: "enableServiceRecommendation",
    }),
    getMenuEpayment() {
      return this.subMenus.find((sm) => sm.id === 1);
    },
    getMenuReminder() {
      return this.subMenus.find((sm) => sm.id === 2);
    },
    getMenuTake() {
      return this.subMenus.find((sm) => sm.id === 3);
    },
    getMenuLaporan() {
      return this.subMenus.find((sm) => sm.id === 4);
    },
    getMenuPelunasanInvoice() {
      return this.subMenus.find((sm) => sm.id === 5);
    },
    getMenuWaVerification() {
      return this.subMenus.find((sm) => sm.id === 6);
    },
    getMenuNotaWa() {
      return this.subMenus.find((sm) => sm.id === 9);
    },
    getMenuCashback() {
      return this.subMenus.find((sm) => sm.id === 7);
    },
    getMenuPointActivePeriod() {
      return this.subMenus.find((sm) => sm.id === 8);
    },
    getMenuServiceRecommendation() {
      return this.subMenus.find((sm) => sm.id === 10);
    },
    getSubTitleEpayment() {
      return this.subTitle.epayment;
    },
    getSubTitleReminder() {
      return this.subTitle.reminder;
    },
    getSubTitleLaporan() {
      return this.subTitle.laporan;
    },
    subtitleAmbilPelunasan() {
      let text = null;
      switch (
        this.$store.state.pengaturanUmumModule.customerAmbilDanLunasi
          .owner_pengaturan_umum.ambil_tanpa_lunasi
      ) {
        case 0:
          text = "Belum Diatur";
          break;
        case 1:
          text = "Semua Konsumen";
          break;
        case 2:
          text = `Diatur ${this.$store.state.pengaturanUmumModule.customerAmbilDanLunasi.customer.length} Konsumen`;
          break;
        default:
          break;
      }
      return text;
    },
    subtitlePelunasanInvoice() {
      let text = null;
      switch (
        this.$store.state.pengaturanUmumModule.pelunasanInvoice
          .bisa_lunasi_invoice
      ) {
        case 0:
          text = "Belum diatur";
          break;
        case 1:
          text = "Semua outlet";
          break;
        case 2:
          text = "Sebagian & Semua";
          break;
        default:
          break;
      }
      return text;
    },
    selectedItemBiaya() {
      let selectedItem = this.pengaturanLaporan.itemBiaya.filter(
        (item) => item.hide === 1
      );
      return selectedItem ? selectedItem : 0;
    },
    selectedSumberDana() {
      let selectedDana = this.pengaturanLaporan.sumberDana.filter(
        (item) => item.hide === 1
      );
      return selectedDana ? selectedDana : 0;
    },
    betaKeys() {
      return betaKeys;
    },
    getSubtitlePointActivePeriod() {
      let value;
      switch (this.pointActivePeriod) {
        case "unlimited":
          value = "Unlimited";
          break;
        case "quartal":
          value = "Quartal (3 Bulan)";
          break;
        case "semester":
          value = "Semester (6 Bulan)";
          break;
        case "tahunan":
          value = "Tahunan (1 Tahun)";
          break;
        default:
          break;
      }
      return value;
    },
  },
  methods: {
    ...mapActions({
      setMenu: `${moduleName}/setMenu`,
      getSettingEpayment: `${moduleName}/getSettingEpayment`,
      getSettingReminder: `${moduleName}/getReminderInfo`,
      getPengaturanLaporan: `${moduleName}/getPengaturanLaporan`,
      getAmbilPelunasanInfo: `${moduleName}/getAmbilPelunasanInfo`,
      getPengaturanUmum: `${moduleName}/getPengaturanUmum`,
      getSettingsV2: `${moduleName}/getSettingsV2`,
      setSumberDana: `${moduleName}/setSumberDana`,
      setItemBiaya: `${moduleName}/setItemBiaya`,
    }),
    async init() {
      this.isLoading = true;
      Promise.all([
        this.setMenu(subMenu),
        this.getSettingEpayment(),
        this.getSettingReminder(),
        this.getListData(),
        this.getAmbilPelunasanInfo(),
        this.getPengaturanUmum(),
        this.getSettingsV2(),
      ])
        .catch((e) => {
          console.log(e);
        })
        .finally(() => (this.isLoading = false));
    },
    back() {
      this.$router.push({ name: "dashboard" });
    },
    linkTo(link) {
      this.$router.push({ name: link });
    },
    getListData() {
      this.getPengaturanLaporan()
        .then((res) => {
          if (!res.data) {
            this.$toast.error(res);
          } else {
            let { code, status, data, msg } = res.data;
            if (status && code === 200) {
              this.setSumberDana(data.sumberDana);
              this.setItemBiaya(data.itemBiaya);
            }
          }
        })
        .catch((e) => {
          this.$toast.error(e);
        });
    },
    async openWaVerificationModal() {
      this.$refs.modalWaVerificationSetting
        .open(this.enableWaVerification)
        .then((acc) => {
          if (acc) {
            this.$refs.modalWaVerificationSetting.close();
            this.$toast.success(
              "Berhasil mengubah Verifikasi WA Daftar Member"
            );
            this.isLoading = true;
            this.getSettingsV2().finally(() => (this.isLoading = false));
          }
        });
    },

    async openServiceRecommendationModal() {
      //
      this.$refs.modalServiceRecommendationSetting
        .open(this.enableServiceRecommendation)
        .then((acc) => {
          if (acc) {
            this.$refs.modalServiceRecommendationSetting.close();
            const isChecked =
              this.$refs.modalServiceRecommendationSetting.isChecked;

            this.$toast.success(
              `Rekomendasi AI di Smartlink Kasir berhasil ${
                isChecked === true ? "diaktifkan" : "dinonaktifkan"
              }`
            );
            this.isLoading = true;
            this.getPengaturanUmum().finally(() => (this.isLoading = false));
          }
        });
    },
  },
};
</script>

<style scoped>
.pengaturan-umum .separator {
  width: unset;
}
.text-container {
  display: flex;
}
.text-container .epayment-container {
  width: 121px;
}
.text-container .reminder-container {
  width: 71px;
}
</style>
